import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useDispatch, useSelector, uninitState, statusSuccess, statusUninit, statusLoading, statusFailed, statusWarning } from '@grandvisionhq/state';
import { fetchList } from '../actions.js';
import { getCCCSubscriptionList } from '../selectors.js';
import NoSubscriptions from './NoSubscriptions/NoSubscriptions.js';

/**
 * This component never renders a list of subscriptions. The business rule is that
 * a user can only have a single subscription, so once the "list" of subscriptions is
 * loader we're forwarding the user to the detail page of that subscription.
 */ const CCCList = ()=>{
    var ref;
    const intl = useIntl();
    const { getLabel  } = intl;
    const dispatch = useDispatch();
    var ref1;
    const list = (ref1 = useSelector(getCCCSubscriptionList)) !== null && ref1 !== void 0 ? ref1 : uninitState();
    var ref2;
    // Need the subscription ID to create a URL.
    const cccSubscriptionId = statusSuccess(list) ? (ref2 = (ref = list.result[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : '' : '';
    const linkProps = useLink({
        route: 'me.cccSubscriptions.detail',
        params: {
            cccSubscriptionId
        }
    });
    const subscriptionDetailPageUrl = linkProps === null || linkProps === void 0 ? void 0 : linkProps.href;
    const location = useLocation();
    React.useEffect(()=>{
        dispatch(fetchList());
    /* Usual method to call a data fetching function only on mount. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (statusUninit(list) || statusLoading(list)) {
        return /*#__PURE__*/ React.createElement(Spinner, {
            "aria-label": getLabel('common.loadingText')
        });
    }
    if (statusFailed(list) || statusWarning(list)) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            title: intl.getLabel('account.ccc.errors.general'),
            className: "alert-m-default"
        });
    }
    if (statusSuccess(list)) {
        /**
     * If the request is successful but returns no subscriptions, we want to show a specific page.
     */ if (list.result.length < 1) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "subscription-list"
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "small",
                component: "h1",
                className: "subscription-list__title"
            }, intl.getLabel('account.ccc.list.title')), /*#__PURE__*/ React.createElement(NoSubscriptions, null));
        }
        /**
     * Forward the user to the detail page of their subscription. Replace
     * the route, because there's no need for them to return to the list
     * page (which will only show a loader and redirect them to the detail
     * page again).
     */ const { hash  } = window.location;
        const url = new URL(`${origin}${subscriptionDetailPageUrl}${hash}`);
        location.replace(url);
    }
    return null;
};

export { CCCList, CCCList as default };
//# sourceMappingURL=CCCList.js.map
